<div class="progress-container">
    <h5 class="top-label" *ngIf="topLabel">{{ topLabel }}</h5>
    <div #circularBar class="circular-bar">
        <div #percentValue class="percent">0%</div>
    </div>
    <h5 class="bottom-label" *ngIf="bottomLabel">{{ bottomLabel }}</h5>

</div>